import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsSkipForward: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 5.714L1 0v16l10-5.714V15h4V1h-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsSkipForward
